<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>
<style>
html,body,#app{
  width: 100%;
  height:100%;
}
</style>
<script>
  import '@/assets/style/global.css'
export default {
  name: 'App',
  provide (){
    return {
      reload:this.reload
    }
  },
  data(){
    return {
      isRouterAlive:true
    }
  },
  mounted(){
    // if (this._isMobile()) {
    //  $("#app").removeClass("pc").addClass("mobile");
    // } else {
    //   $("#app").removeClass("mobile").addClass("pc");
    // }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
   reload (){
      this.isRouterAlive = false
      this.$nextTick(function(){
          this.isRouterAlive = true
      })
   }
  },
}
</script>




// WEBPACK FOOTER //
// src/App.vue